import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { IconColor } from '@freelancer/ui/icon';
import {
  RibbonColor,
  RibbonOrientation,
  RibbonPlacement,
} from './ribbon.types';

@Component({
  selector: 'fl-ribbon',
  template: `
    <fl-icon
      *ngIf="icon"
      [label]="iconLabel"
      [name]="icon"
      [color]="IconColor.LIGHT"
    ></fl-icon>
    <span class="text-light text-xxsmall font-bold">
      <ng-content></ng-content>
    </span>
  `,
  styleUrls: ['./ribbon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RibbonComponent {
  IconColor = IconColor;

  @Input() iconLabel?: string;

  @HostBinding('attr.data-color')
  @Input()
  color: RibbonColor = RibbonColor.PRIMARY;

  @HostBinding('attr.data-icon')
  @Input()
  icon?: string;

  @HostBinding('attr.data-orientation')
  @Input()
  orientation = RibbonOrientation.HORIZONTAL;

  @HostBinding('attr.data-placement')
  @Input()
  placement: RibbonPlacement = RibbonPlacement.RIGHT;

  @HostBinding('attr.data-placement-tablet')
  @Input()
  placementTablet?: RibbonPlacement;

  @HostBinding('attr.data-placement-desktop')
  @Input()
  placementDesktop?: RibbonPlacement;
}
